import { useState } from "react";
import "./TooltipUI.css";

const TooltipUI2 = ({ children, text }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && text && (
        <div className="tooltip2">
          {text}
          <span className="tooltip-arrow2" />
        </div>
      )}
    </div>
  );
};

export default TooltipUI2;